/**
 * @generated SignedSource<<32e244fad853543f8d71ca5f47d5a8ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BucketDurationControlNode$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useGetValidCourseAndDurationSelections_Node">;
  readonly " $fragmentType": "BucketDurationControlNode";
};
export type BucketDurationControlNode$key = {
  readonly " $data"?: BucketDurationControlNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"BucketDurationControlNode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BucketDurationControlNode",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetValidCourseAndDurationSelections_Node"
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "3bf8fc413b5ed43aa49c2eb0c9074506";

export default node;
